export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "fuwu",
    name: "服务介绍",
    description: "全面了解 91.cn 平台提供的各项核心服务功能与使用场景，帮助您快速上手。",
    icon: "ri-apps-2-line",
    articleCount: 12,
  },
  {
    slug: "zhinan",
    name: "使用指南",
    description: "详细的使用教程和操作指引，从入门到精通，手把手带您玩转 91.cn。",
    icon: "ri-book-open-line",
    articleCount: 18,
  },
  {
    slug: "dongtai",
    name: "平台动态",
    description: "第一时间了解 91.cn 的产品更新、功能迭代和重要公告，不错过每一个新变化。",
    icon: "ri-newspaper-line",
    articleCount: 8,
  },
  {
    slug: "anquan",
    name: "安全保障",
    description: "了解 91.cn 的安全防护体系、隐私政策和数据保护措施，安心使用每一刻。",
    icon: "ri-shield-check-line",
    articleCount: 6,
  },
  {
    slug: "hezuo",
    name: "合作生态",
    description: "探索 91.cn 的开放平台与合作计划，与我们一起共建互联网服务新生态。",
    icon: "ri-links-line",
    articleCount: 10,
  },
];